import { ICreditCardDetails } from './credit-card-details';
import { IPingTransactionDetails } from './ping-transaction-details';

export interface ITopUpAccountRequest {
    /**
     * The amount to top up the member's account by.
     */
    amount: number;
    /**
     * The details of the credit card to use for topping up. If this is not supplied then it is assumed the
     * member is trying to use their saved credit card details.
     */
    creditCardDetails?: ICreditCardDetails;
    /**
     * The member's Trade Me password. This is no longer required for top ups, but for backwards-compatibility reasons,
     * if it is provided then we will check it.
     */
    password?: string;
    /**
     * The type of fund source. If a FundSourceID is not present the API will use the default fund source of this type.
     * If a FundSourceID is supplied then its type must match this type. However if a FundSourceID is present this field is optional.
     */
    pingTransactionDetails?: IPingTransactionDetails;
}
